// Auto-detect backend URL: use env var if set, otherwise use current origin (works on any deployed domain)
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
export const API = `${BACKEND_URL}/api`;
export const EMBED_DOMAIN = process.env.REACT_APP_EMBED_DOMAIN || BACKEND_URL;
export const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
